import React from 'react';
import {Menu, MenuLabelProps} from '@mantine/core';

export const EtroMenuLabel: React.FC<MenuLabelProps> = props => {
  return <Menu.Label {...props} />;
};
